import { createSlice } from '@reduxjs/toolkit';

const utilSlice = createSlice({
	name: 'util',
	initialState: {
		agencies: [],
		// Set when ANY API call returns a forceLogout error (e.g. subscription
		// expired). Holds the error body { error, message, forceLogout }.
		subscriptionError: null,
		// Set when the server refuses a lead-status change because the access token of
		// the lead's ad platform (Meta, TikTok…) is unusable. { reason, platform, kind,
		// message }; one modal reads it.
		adTokenBlock: null,
	},
	reducers: {
		setAgenciesData(state, action) {
			const data = action.payload;

			state.agencies = data;
		},
		setSubscriptionError(state, action) {
			state.subscriptionError = action.payload;
		},
		clearSubscriptionError(state) {
			state.subscriptionError = null;
		},
		// Ignored while one is already showing: three status controls can fail from
		// the same cause at once, and a second modal on top of the first helps no one.
		showAdTokenBlock(state, action) {
			if (!state.adTokenBlock) state.adTokenBlock = action.payload;
		},
		clearAdTokenBlock(state) {
			state.adTokenBlock = null;
		},
	},
});

export const {
	setAgenciesData,
	setSubscriptionError,
	clearSubscriptionError,
	showAdTokenBlock,
	clearAdTokenBlock,
} = utilSlice.actions;

export default utilSlice.reducer;
